module.exports = __webpack_public_path__ + "static/media/grand_mum_walk03.ad13e082.png";